import CampaignPlanningConfirmationModal from "./CampaignPlanningConfirmationModal";

class CampaignPlanningConfirmationModalForbiddenClass extends CampaignPlanningConfirmationModal {
    constructor() {
        super();

        this.main = document.getElementById('campaign_planning_confirmation_modal_forbidden');

        this._btnClose = this.main.querySelector('.btn_close');
        this._btnClose.addEventListener('click', this._onClickBtnClose.bind(this));
    }

    show() {
        super.show();
    }

    _onClickBtnOk(e) {
        e.preventDefault();

        this.hide();
    }

    _onClickBtnClose(e) {
        e.preventDefault();

        this.hide();
    }
}
const CampaignPlanningConfirmationModalForbidden = new CampaignPlanningConfirmationModalForbiddenClass();

Object.seal(CampaignPlanningConfirmationModalForbidden);

export default CampaignPlanningConfirmationModalForbidden;